import useTranslation from "@/hooks/useTranslation";
import { useYoudao } from "@/hooks/useTranslator";
import { currentUserState } from "@/stores/common";
import { IconButton } from "@material-ui/core";
import TranslateRoundedIcon from "@material-ui/icons/TranslateRounded";
import React from "react";
import { useRecoilValue } from "recoil";

interface IProps {
  id: string;
}

const TranslateButton: React.FC<IProps> = ({ id }) => {
  const { i18n } = useTranslation();
  const { loading, setTargetYoudao } = useYoudao();
  const currentUser = useRecoilValue(currentUserState);

  const handleClick = () => {
    setTargetYoudao(id);
  };

  if (i18n.language !== "en" && currentUser?.id) {
    return (
      <IconButton color="primary" onClick={handleClick} disabled={loading}>
        <TranslateRoundedIcon fontSize="small" />
      </IconButton>
    );
  }
  return <React.Fragment />;
};

export default TranslateButton;
